export class InvalidTextSearchInputError extends Error {}
